import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Farbige Rollen-Pille. Einzige Quelle für die Rollen-Farbgebung (data-role-Variante),
 * damit Benutzerübersicht und Einladen-Seite identisch aussehen (NEX-620).
 */
@Component({
  selector: 'app-role-badge',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (role()) {
      <span class="role-badge" [attr.data-role]="role()">{{ 'roles.' + role() | translate }}</span>
    }
  `,
  styleUrl: './role-badge.component.scss',
})
export class RoleBadgeComponent {
  readonly role = input.required<string>();
}
